import classNames from 'classnames'
import { AllHTMLAttributes } from 'react'

type TableBodyProps = { children: React.ReactNode } & AllHTMLAttributes<HTMLDivElement>
export default function TableBody({ children, className }: Readonly<TableBodyProps>) {
  return <tbody className={classNames('TableBody', className)}>{children}</tbody>
}
